/* eslint-disable */
import { Button, Divider } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import MuiLink from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown, isWidthUp } from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import EmailIcon from '@material-ui/icons/Email';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import ErrorIcon from '@material-ui/icons/Error';
import WorkIcon from '@material-ui/icons/Work';
import { UI_EDIT_PROFILE_CLICK } from '../../State/Store/UI/UI.types';
import cn from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import EditProfileDialogComponent from '../../Components/EditProfileDialog/EditProfileDialog.component';
import NotificationsPanel from '../../Components/NotificationsSettings/NotificationsSettings.component';
import Page from '../../Components/Page/Page.component';
import SpeedDialWrapperComponent from '../../Components/SpeedDialWrapper/SpeedDialWrapper.component';
import Spinner from '../../Components/Spinner/Spinner.component';
import withServices from '../../Contexts/Services/WithServices.context';
import { createPlaceOrderPageLink } from '../PlaceOrder/PlaceOrder.page.route';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import createUserProfileActionCreators from '../../State/Store/UserProfile/UserProfile.actions';
import envGet from '../../Support/Env/Get/EnvGet.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import './Profile.page.i18n';
import ProfilePagePropTypes from './Profile.page.props';
import ProfilePageSidebar from './Profile.page.sidebar';
import profilePageStyles from './Profile.page.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

const REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS` }) === `true`;

/**
 * ProfilePageComponent
 * @export
 * @class ProfilePageComponent
 * @extends {React.Component<ProfilePageComponentComposedProps, ProfilePageComponentState>}
 */
export class ProfilePageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<ProfilePageComponentProps>}
   * @memberof ProfilePageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`ProfilePage`}
   * @memberof ProfilePageComponent
   */
  static displayName = `ProfilePage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof ProfilePageComponent
   */
  static propTypes = ProfilePagePropTypes;

  /**
   * Data specific to the `<ProfilePage />` instance
   * @type {ProfilePageComponentState}
   * @memberof ProfilePageComponent
   */
  state = {};

  // API calls should be moved to Actions in redux.

  /**
   * When the Component mounts, update the
   * @returns {void} void
   * @memberof ProfilePageComponent
   */
  async componentDidMount() {
    this.getUserInfoAPI();
    this.setState({
      showEditProfileDialog: false,
      snack: { autoHideDuration: 6000, message: ``, show: false, type: `` },
    });
    return;
  }

  /**
   * When the Component updates grab new profile if needed
   * @param {Object} prevProps previous props
   * @returns {void} void
   * @memberof ProfilePageComponent
   */
  async componentDidUpdate(prevProps) {
    const {
      userInfo: { mobilePhone },
    } = this.props;
    if (prevProps.userInfo.mobilePhone !== mobilePhone) {
      this.getUserInfoAPI();
    }
    return;
  }

  /**
   * Function for API call
   * @memberof ProfilePageComponent
   * @returns {void} void
   */
  getUserInfoAPI = async () => {
    const { services } = this.props;
    try {
      // This should be in an action
      const userInfo = await services.userService.getCurrentUser();
      // We update state here from the API and not from the redux store becuase we want to see the API data chanegs.
      this.setState({
        userInfo,
      });
    } catch (err) {
      this.setState({
        err,
      });
    }
    return;
  };

  /**
   * Opens the dialog
   * @memberof ProfilePageComponent
   * @returns {void} void
   */
  onOpenEditProfileDialog = () => {
    const { actions } = this.props;
    actions.uiTriggered({
      payload: {
        data: {
          name: `editProfileClick`,
        },
      },
      type: UI_EDIT_PROFILE_CLICK,
    });
    this.setState({ showEditProfileDialog: true });
    return;
  };

  /**
   * Closes the dialog
   * @memberof ProfilePageComponent
   * @returns {void} void
   */
  onCloseEditProfileDialog = () => {
    this.setState({ showEditProfileDialog: false });
    return;
  };

  /**
   * Show the snankbar message
   * @memberof ProfilePageComponent
   * @type {`ProfilePageComponent`}
   * @param {Object} snack  this is the snackbar parmaters
   * @returns {void} void
   */
  editProfileMessage = (snack) => {
    this.setState({ snack: { autoHideDuration: snack.autoHideDuration, message: snack.message, show: snack.show, type: snack.type } });
    if (snack.type === `success`) {
      this.getUserInfoAPI();
      return;
    }
  };

  /**
   * For handling the clsoe snankbar message
   * @memberof ProfilePageComponent
   * @type {`ProfilePageComponent`}
   * @param {Object} event  the event
   * @param {Object} reason  the reason
   * @returns {void} void
   */
  onHandleCloseMessage = (event, reason) => {
    this.setState({ snack: { autoHideDuration: 6000, message: ``, show: false, type: `` } });
    return;
  };

  /**
   * Render the field
   * @param {string} label The label
   * @param {string} value The value
   * @param {React.Component} icon The icon
   * @returns {React.Component} The rendered field
   * @memberof ProfilePageComponent
   */
  renderField(label, value, icon) {
    const { classes } = this.props;
    return (
      <Grid alignItems="center" classes={{ item: classes.field }} container item spacing={2} wrap="nowrap">
        <Grid classes={{ item: classes.icon }} item>
          {icon}
        </Grid>
        <Grid item xs zeroMinWidth>
          <Typography className={classes.fieldValue} data-mf-replace-inner={MFSDR}>
            {value}
          </Typography>
          {!value && <div className={cn(classes.textDecorationUnderline,classes.cursorPointer,classes.fontWeight500)} onClick={this.onOpenEditProfileDialog}>Add {label}</div>}
          <Typography component="div" variant="caption">{label}</Typography>
        </Grid>
      </Grid>
    );
  }

  /**
   * Render the profile
   * @returns {React.Component} The rendered profile
   * @memberof ProfilePageComponent
   */
  renderProfile() {
    const { classes, history, filters, actions, width } = this.props;
    const { err, showEditProfileDialog, snack, userInfo } = this.state;

    if (err) {
      return <Typography variant="h5">Error Fetching Profile.</Typography>;
    }
    if (!userInfo) {
      return <Spinner />;
    }
    const { jobTitle, email, firstName, lastName, mobilePhone, primaryPhone } = userInfo;

    return (
      <Grid container item sm={8} xs={12}>
        <Grid alignItems="center" classes={{ container: classes.profileHeader }} container item spacing={2} wrap="nowrap">
          <Grid item>
            <Avatar>
              <PersonIcon />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography variant="h5" data-mf-replace-inner={MFSDR}>{`${firstName} ${lastName}`}</Typography>
          </Grid>
        </Grid>
        <Grid container direction="column" item>
          {this.renderField(`Email`, email, <EmailIcon />)}
          {this.renderField(`Mobile`, mobilePhone, <PhoneIcon />)}
          {this.renderField(`Phone`, primaryPhone, <PhoneIcon />)}
          {this.renderField(`Job Title`, jobTitle, <WorkIcon />)}
        </Grid>

        <Button color="primary" onClick={this.onOpenEditProfileDialog} variant="contained">Edit Profile</Button>

        <Snackbar
          action={[
            <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={this.onHandleCloseMessage}>
              <CloseIcon />
            </IconButton>,
          ]}
          autoHideDuration={snack.autoHideDuration}
          onClose={this.onHandleCloseMessage}
          open={snack.show}
          message={
            <span className={classes.snackbarMessage} id="client-snackbar">
              {snack.type===`error` && <ErrorIcon className={classes.snackbarIcon} />}
              {snack.message}
            </span>
          }
          anchorOrigin={{
            horizontal: `left`,
            vertical: `bottom`,
          }}
          className={classes.snackbar}
          ContentProps={{ classes: { root: snack.type === `error` ? classes.error : null } }}
        />
        <EditProfileDialogComponent
          editProfileMessage={this.editProfileMessage}
          onCloseEditProfileDialog={this.onCloseEditProfileDialog}
          open={showEditProfileDialog}
          userInfo={userInfo}
        />
      </Grid>
    );
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<ProfilePage />`
   * @memberof ProfilePageComponent
   */
  render() {
    const { classes, width } = this.props;
    const isSmall = isWidthDown(`xs`, width);
    const isLarge = isWidthUp(`lg`, width);
    return (
      <Page
        className={cn(classes.root)}
        heading="ProfilePage.PageTitle"
        hideLogo={isSmall}
        hideMenuIcon={isLarge}
        overflow="auto"
        sidebarContent={<ProfilePageSidebar />}
        title="ProfilePage.PageTitle"
      >
        {this.renderProfile()}
        {/* out of scope
        {REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS && <Divider className={classes.divider} />}
        {REACT_APP_BORAL_FEATURE_TOGGLE_NOTIFICATIONS_SETTINGS && <NotificationsPanel />} */}
      </Page>
    );
  }
}

/** @type {React.ComponentClass<ProfilePageComponentProps>} */
const ProfilePage = compose(
  withWidth(),
  withRouter,
  withServices,
  withStyles(themeCreateInjectableStyles(profilePageStyles), { withTheme: true }),
  connect(
    (state) => ({
      userInfo: userProfileSelector(state),
      filters: state.filters,
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...createUserProfileActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(ProfilePageComponent);

export default ProfilePage;
